<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-contain`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.40332 3.28906C11.0027 3.28933 13.1094 5.39666 13.1094 7.99609C13.1094 10.5955 11.0027 12.7029 8.40332 12.7031H3.55566C3.18839 12.7031 2.89062 12.4054 2.89062 12.0381C2.89062 11.6708 3.18839 11.373 3.55566 11.373H8.40332C10.2682 11.3728 11.7803 9.86099 11.7803 7.99609C11.7803 6.1312 10.2682 4.6194 8.40332 4.61914H3.55566C3.18839 4.61914 2.89062 4.32137 2.89062 3.9541C2.89062 3.58683 3.18839 3.28906 3.55566 3.28906H8.40332Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineContain',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
